import React from 'react';

import { Container } from './styles';

interface TooltipProps {
  title: string;
  className?: string;
  errorStyle?: object;
}

const Tooltip: React.FC<TooltipProps> = ({
  title,
  className = '',
  errorStyle = {},
  children,
}) => {
  return (
    <Container className={className} style={errorStyle}>
      {children}
      <span>{title}</span>
    </Container>
  );
};

export default Tooltip;
